var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2370 5113 c-468 -44 -863 -180 -1220 -419 -385 -257 -683 -597 -885 -1009 -168 -340 -248 -661 -262 -1040 -15 -426 73 -832 263 -1214 133 -269 271 -459 488 -677 221 -220 412 -357 681 -489 188 -92 309 -137 500 -185 598 -150 1209 -85 1754 186 274 136 453 266 677 489 217 217 354 407 488 676 309 621 350 1331 115 1993 -47 133 -163 373 -235 486 -211 333 -537 653 -856 843 -413 246 -871 371 -1338 365 -74 0 -151 -3 -170 -5z m440 -373 c1006 -122 1791 -896 1926 -1900 29 -219 14 -536 -35 -757 -204 -909 -960 -1590 -1891 -1703 -122 -15 -398 -12 -526 4 -1005 133 -1782 918 -1904 1926 -13 109 -13 391 0 500 121 1001 893 1787 1890 1925 117 16 426 19 540 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587 3645 c-92 -32 -141 -124 -117 -217 10 -38 58 -90 423 -455 l412 -413 -412 -412 c-362 -364 -413 -418 -423 -456 -35 -134 88 -257 222 -222 38 10 92 61 456 423 l412 412 413 -412 c363 -362 417 -413 455 -423 134 -35 257 88 222 222 -10 38 -61 92 -423 456 l-412 412 412 413 c362 363 413 417 423 455 35 134 -88 257 -222 222 -38 -10 -92 -61 -455 -423 l-413 -412 -412 412 c-350 349 -419 413 -453 422 -50 14 -61 13 -108 -4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecline);
export default __webpack_public_path__ + "static/media/Decline.2d724b58230252ecf7633ff580fc761c.svg";
export { ForwardRef as ReactComponent };